import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/dist/client';
import B2BTheme from '@thd-olt-global/b2b-theme';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { whyDidYouRender } from '../wdyr';
import { App } from './App';
import { getRoutes } from './routes';
import { isLoggedIn } from './helpers';

NewRelicBridge.init();
whyDidYouRender.init();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext({
    opts: {
      federation: true,
    }
  });

  client.setExperienceRoutes(getRoutes());

  if (client.customer.type === 'b2b') {
    client.setTheme({ name: 'b2b', template: B2BTheme });
  } else {
    const isGuest = typeof window !== 'undefined' && !isLoggedIn();

    if (isGuest) {
      const signInURL = typeof window !== 'undefined'
      && `https://${window.location.hostname}/auth/view/signin?redirect=${encodeURIComponent(
        window.location.pathname + window.location.search,
      )}`;
      window.location.href = signInURL;
    } else {
      const redirectMyHomepageURL = typeof window !== 'undefined'
      && `https://${window.location.hostname}`;
      window.location.href = redirectMyHomepageURL;
    }
  }

  client.render(<App
    prefetchPip={client.featureSwitches.prefetchPip}
    productPodHoverDelay={client.featureSwitches.productPodHoverDelay}
  />);
});